module.exports = __webpack_public_path__ + "img/image-not-available.3ad7ccfa.jpg";